module.exports = "/dist/montserrat-latin-800.svg?6cbef7b359c0bb255d48a7baec506ed5";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800.svg
// module id = 80
// module chunks = 0